/* ============================================================
   ประเภทหน่วยบรรจุของสินค้า (er_pg.pack_type)

   ใช้ร่วมกันทุกหน้า เพื่อไม่ให้ตัวเลขน้ำหนักพาเลตกระจายอยู่หลายที่
   ถ้าน้ำหนักพาเลตเปลี่ยน ให้แก้ที่ไฟล์นี้ที่เดียว
   (เอกสารที่ออกไปแล้วไม่กระทบ เพราะ Invoice เก็บค่าที่ใช้ตอนนั้นไว้ใน
    er_invdetail.pallet_wt แล้ว)
============================================================ */

export const PACK_TYPE = {
  CARTON: "CARTON",
  PALLET_P: "PALLET_P",
  PALLET_W: "PALLET_W",
  /* ข้อมูลเก่าที่บันทึกเป็น PALLET เฉย ๆ ยังไม่ระบุวัสดุ */
  PALLET: "PALLET",
};

/* น้ำหนักบรรจุภัณฑ์ขนส่งต่อ 1 หน่วย (กิโลกรัม) — บวกเข้า Gross Weight เท่านั้น
   Net Weight คือน้ำหนักสินค้าล้วน ไม่รวมบรรจุภัณฑ์ตามหลักสากล */
export const PALLET_WEIGHT_KG = {
  [PACK_TYPE.PALLET_W]: 21,
  [PACK_TYPE.PALLET_P]: 7.8,
  /* ของเก่าที่ไม่ระบุวัสดุ ใช้พาเลตไม้เป็นค่าอนุรักษ์นิยม (หนักกว่า) */
  [PACK_TYPE.PALLET]: 21,
  /* กล่องกระดาษ : GW/กล่อง (จาก Packing Goods) รวมน้ำหนักกล่องอยู่แล้ว
     เดิมบวกเพิ่มกล่องละ 1 กก. ทำให้ GW รวมเกินจริง จึงเป็น 0 */
  [PACK_TYPE.CARTON]: 0,
};

export const PACK_TYPE_LABEL = {
  [PACK_TYPE.CARTON]: "Carton",
  [PACK_TYPE.PALLET_P]: "Pallet พลาสติก",
  [PACK_TYPE.PALLET_W]: "Pallet ไม้",
  [PACK_TYPE.PALLET]: "Pallet (ไม่ระบุวัสดุ)",
};

/* หน่วยขายที่ควรใช้เป็นค่าตั้งต้นในใบ Invoice ตามชนิดหน่วยบรรจุ */
export const PACK_TYPE_SALE_UNIT = {
  [PACK_TYPE.CARTON]: "CASE",
  [PACK_TYPE.PALLET_P]: "PALLET",
  [PACK_TYPE.PALLET_W]: "PALLET",
  [PACK_TYPE.PALLET]: "PALLET",
};

export const isPallet = (packType) =>
  String(packType || "").toUpperCase().startsWith("PALLET");

/* น้ำหนักพาเลตต่อหน่วยของ pack_type นั้น ไม่รู้จัก = 0 */
export const palletWeightOf = (packType) =>
  Number(PALLET_WEIGHT_KG[String(packType || "").toUpperCase()] || 0);

export const saleUnitOf = (packType) =>
  PACK_TYPE_SALE_UNIT[String(packType || "").toUpperCase()] || "CASE";
